module.exports = __webpack_public_path__ + "static/simplyfood-logo-99c2b7846b49ded5b0b84012ceb05819.svg";